import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { loadOnboardingState, persistOnboardingState, resetOnboardingState } from './onboardingStorage';
import { CHECKLIST_ITEMS } from './onboardingSteps';
import { ONBOARDING_EVENTS, trackOnboarding } from './onboardingAnalytics';
import OnboardingContext from './onboardingContext';
import { onboardingEnabled } from '../../brand/tenant';

// Ð¡Ð¾ÑÑÐ¾ÑÐ½Ð¸Ðµ Ð¾Ð±ÑÑÐµÐ½Ð¸Ñ Ð½Ð° Ð²ÑÑ Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ: Ð¸Ð´ÑÑ Ð»Ð¸ ÑÑÑ, ÑÑÐ¾ Ð¿ÑÐ¾Ð¹Ð´ÐµÐ½Ð¾ Ð² ÑÐµÐº-Ð»Ð¸ÑÑÐµ.
// ÐÑÐ¾Ð²Ð°Ð¹Ð´ÐµÑ ÑÑÐ¾Ð¸Ñ Ð²Ð½ÑÑÑÐ¸ ÑÐ¾ÑÑÐµÑÐ° â ÐµÐ¼Ñ Ð½ÑÐ¶ÐµÐ½ Ð°Ð´ÑÐµÑ ÑÑÑÐ°Ð½Ð¸ÑÑ, ÑÑÐ¾Ð±Ñ Ð¾ÑÐ¼ÐµÑÐ°ÑÑ
// Ð¿ÑÐ¾Ð¹Ð´ÐµÐ½Ð½ÑÐµ ÑÐ°Ð³Ð¸. Ð¡Ð°Ð¼ ÐºÐ¾Ð½ÑÐµÐºÑÑ Ð¸ ÑÑÐº Ðº Ð½ÐµÐ¼Ñ Ð»ÐµÐ¶Ð°Ñ Ð² onboardingContext.js.

// ÐÐ°ÐºÐ¾Ð¹ Ð¿ÑÐ½ÐºÑ ÑÐµÐº-Ð»Ð¸ÑÑÐ° Ð·Ð°ÐºÑÑÐ²Ð°ÐµÑ Ð·Ð°ÑÐ¾Ð´ Ð½Ð° ÑÑÑÐ°Ð½Ð¸ÑÑ. ÐÑÐ¾Ð²ÐµÑÑÐµÐ¼ Ð¿Ð¾ Ð¿Ð¾ÑÑÐ´ÐºÑ,
// Ð±ÐµÑÑÐ¼ Ð¿ÐµÑÐ²Ð¾Ðµ ÑÐ¾Ð²Ð¿Ð°Ð´ÐµÐ½Ð¸Ðµ.
const ROUTE_RULES = [
  { item: 'profile', test: (path) => path === '/profile' },
  { item: 'client', test: (path) => path.startsWith('/client/create') },
  { item: 'deal', test: (path) => path === '/deals/create' },
];
// ÐÑÐ½ÐºÑÑ Â«ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð·Ð°ÑÐ²ÐºÑ Ð² Ð±Ð°Ð½ÐºÐ¸Â» Ð¸ Â«ÐÐ¾ÑÐ¼Ð¾ÑÑÐµÑÑ ÑÐµÑÐµÐ½Ð¸Ñ Ð±Ð°Ð½ÐºÐ¾Ð²Â» Ð¿Ð¾ Ð°Ð´ÑÐµÑÑ
// ÑÑÑÐ°Ð½Ð¸ÑÑ Ð½Ðµ Ð¾Ð¿ÑÐµÐ´ÐµÐ»Ð¸ÑÑ â Ð¸Ñ Ð·Ð°ÐºÑÑÐ²Ð°ÐµÑ ÑÑÑÐ°Ð½Ð¸ÑÐ° ÐºÑÐµÐ´Ð¸ÑÐ° Ð² ÑÐ´ÐµÐ»ÐºÐµ, ÐºÐ¾Ð³Ð´Ð°
// Ð²Ð¸Ð´Ð¸Ñ ÑÐµÐ°Ð»ÑÐ½ÑÐµ Ð¾Ð±ÑÐ°ÑÐµÐ½Ð¸Ñ Ð¸ Ð¾ÑÐ²ÐµÑÑ Ð±Ð°Ð½ÐºÐ¾Ð² (DealCredits.jsx).

export const OnboardingProvider = ({ children }) => {
  const user = useSelector((state) => state.user);
  const userId = user?.id;
  const location = useLocation();

  // Ð£ Ð±ÑÐ¾ÐºÐµÑÐ¾Ð² Ð¿Ð°ÑÑÐ½ÑÑÐ¾Ð² Ð¾Ð±ÑÑÐµÐ½Ð¸Ñ Ð½ÐµÑ: Ð½Ð¸ ÑÑÑÐ°, Ð½Ð¸ ÑÐµÐº-Ð»Ð¸ÑÑÐ°, Ð½Ð¸ ÐºÐ½Ð¾Ð¿ÐºÐ¸
  // Â«ÐÑÐ¾Ð¹ÑÐ¸ Ð¾Ð±ÑÑÐµÐ½Ð¸Ðµ Ð·Ð°Ð½Ð¾Ð²Ð¾Â» â ÑÐ°Ð³Ð¸ Ð½Ð°Ð¿Ð¸ÑÐ°Ð½Ñ Ð¿Ð¾Ð´ ÑÐ°Ð·Ð´ÐµÐ»Ñ DOSCAR.
  const available = onboardingEnabled();

  const [tourRunning, setTourRunning] = useState(false);
  const [checklistDone, setChecklistDone] = useState([]);
  // ÐÐ¾ÐºÐ° ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ðµ Ð½Ðµ Ð¿ÑÐ¸ÑÐ»Ð¾ Ñ ÑÐµÑÐ²ÐµÑÐ°, Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼: Ð¸Ð½Ð°ÑÐµ ÑÐµÐ»Ð¾Ð²ÐµÐº,
  // ÐºÐ¾ÑÐ¾ÑÑÐ¹ ÑÑÑ ÑÐ¶Ðµ Ð¿ÑÐ¾ÑÐ¾Ð´Ð¸Ð», ÑÐ²Ð¸Ð´Ð¸Ñ ÐµÐ³Ð¾ ÐµÑÑ ÑÐ°Ð·.
  const [checklistHidden, setChecklistHidden] = useState(true);
  const [loaded, setLoaded] = useState(false);

  // Ð§ÑÐ¾Ð±Ñ Ð½Ðµ Ð³ÑÑÐ·Ð¸ÑÑ Ð¸ Ð½Ðµ Ð·Ð°Ð¿ÑÑÐºÐ°ÑÑ ÑÑÑ Ð¿Ð¾Ð²ÑÐ¾ÑÐ½Ð¾ Ð¿ÑÐ¸ ÐºÐ°Ð¶Ð´Ð¾Ð¼ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¸ Ð¿ÑÐ¾ÑÐ¸Ð»Ñ.
  const loadedFor = useRef(null);
  // ÐÐ¾ÑÐ»ÐµÐ´Ð½ÐµÐµ ÑÐ¾ÑÑÐ°Ð½ÑÐ½Ð½Ð¾Ðµ ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ðµ â ÑÑÐ¾Ð±Ñ ÑÐ»Ð°ÑÑ Ð½Ð° ÑÐµÑÐ²ÐµÑ ÑÐµÐ»Ð¸ÐºÐ¾Ð¼.
  const stateRef = useRef({ tourSeen: false, checklist: [], checklistHidden: false });

  const startTour = useCallback((reason = 'manual') => {
    setTourRunning(true);
    trackOnboarding(ONBOARDING_EVENTS.tourStarted, { reason });
  }, []);

  const persist = useCallback(
    (patch) => {
      stateRef.current = { ...stateRef.current, ...patch };
      persistOnboardingState(userId, stateRef.current);
    },
    [userId],
  );

  // ÐÐµÑÐ²ÑÐ¹ Ð²ÑÐ¾Ð´: ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ðµ Ð±ÐµÑÑÐ¼ Ñ ÑÐµÑÐ²ÐµÑÐ° Ð¸, ÐµÑÐ»Ð¸ ÑÑÑ ÐµÑÑ Ð½Ðµ Ð¿ÑÐ¾ÑÐ¾Ð´Ð¸Ð»Ð¸,
  // Ð·Ð°Ð¿ÑÑÐºÐ°ÐµÐ¼ ÑÐ°Ð¼Ð¸. ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ Ð±ÐµÐ· id (Ð¿ÑÐ¾ÑÐ¸Ð»Ñ ÐµÑÑ Ð½Ðµ Ð·Ð°Ð³ÑÑÐ·Ð¸Ð»ÑÑ) Ð¶Ð´ÑÑ â
  // Ð¸Ð½Ð°ÑÐµ Ð¿Ð¾ÐºÐ°Ð¶ÐµÐ¼ ÑÑÑ Ð½Ð° Ð¿ÑÑÑÐ¾Ð¹ ÑÑÑÐ°Ð½Ð¸ÑÐµ.
  useEffect(() => {
    if (!available || !userId || loadedFor.current === userId) return;
    loadedFor.current = userId;

    let cancelled = false;

    loadOnboardingState(userId).then((state) => {
      if (cancelled) return;

      stateRef.current = state;
      setChecklistDone(state.checklist);
      setChecklistHidden(state.checklistHidden);
      setLoaded(true);

      if (!state.tourSeen) {
        setChecklistHidden(false);
        startTour('first_login');
      }
    });

    return () => {
      cancelled = true;
    };
  }, [userId, startTour]);

  const finishTour = useCallback(
    (outcome, stepId, stepNumber) => {
      setTourRunning(false);
      persist({ tourSeen: true });

      if (outcome === 'skipped') {
        trackOnboarding(ONBOARDING_EVENTS.tourSkipped, { stepId, stepNumber });
      } else {
        trackOnboarding(ONBOARDING_EVENTS.tourFinished, { steps: stepNumber });
      }
    },
    [persist],
  );

  const completeChecklistItem = useCallback(
    (item) => {
      if (!CHECKLIST_ITEMS.includes(item)) return;

      setChecklistDone((prev) => {
        if (prev.includes(item)) return prev;

        const next = CHECKLIST_ITEMS.filter((name) => prev.includes(name) || name === item);
        persist({ checklist: next });
        trackOnboarding(ONBOARDING_EVENTS.checklistItemDone, { item, done: next.length });
        return next;
      });
    },
    [persist],
  );

  // ÐÑÐ½ÐºÑÑ, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð·Ð°ÐºÑÑÐ²Ð°ÑÑÑÑ Ð¿ÑÐ¾ÑÑÐ¾ Ð·Ð°ÑÐ¾Ð´Ð¾Ð¼ Ð½Ð° Ð½ÑÐ¶Ð½ÑÑ ÑÑÑÐ°Ð½Ð¸ÑÑ. ÐÐ¾ÐºÐ° Ð¸Ð´ÑÑ
  // ÑÑÑ â Ð½Ðµ Ð·Ð°ÐºÑÑÐ²Ð°ÐµÐ¼: Ð¿Ð¾ ÑÐ°Ð·Ð´ÐµÐ»Ð°Ð¼ ÑÐ¾Ð´Ð¸Ñ Ð¾Ð½, Ð° Ð½Ðµ ÑÐµÐ»Ð¾Ð²ÐµÐº.
  useEffect(() => {
    if (!loaded || checklistHidden || tourRunning) return;

    const rule = ROUTE_RULES.find((item) => item.test(location.pathname));
    if (rule) completeChecklistItem(rule.item);
  }, [location.pathname, loaded, checklistHidden, tourRunning, completeChecklistItem]);

  const hideChecklist = useCallback(
    (reason = 'manual') => {
      setChecklistHidden(true);
      persist({ checklistHidden: true });
      trackOnboarding(ONBOARDING_EVENTS.checklistHidden, { reason, done: checklistDone.length });
    },
    [persist, checklistDone.length],
  );

  const restartOnboarding = useCallback(() => {
    if (!available) return;

    stateRef.current = { tourSeen: false, checklist: [], checklistHidden: false };
    resetOnboardingState(userId);

    setChecklistDone([]);
    setChecklistHidden(false);
    startTour('restart');
  }, [available, userId, startTour]);

  const value = useMemo(
    () => ({
      available,
      tourRunning: available && tourRunning,
      startTour,
      finishTour,
      checklistDone,
      checklistHidden: !available || checklistHidden,
      completeChecklistItem,
      hideChecklist,
      restartOnboarding,
      allChecklistDone: CHECKLIST_ITEMS.every((item) => checklistDone.includes(item)),
    }),
    [
      available,
      tourRunning,
      startTour,
      finishTour,
      checklistDone,
      checklistHidden,
      completeChecklistItem,
      hideChecklist,
      restartOnboarding,
    ],
  );

  return <OnboardingContext.Provider value={value}>{children}</OnboardingContext.Provider>;
};

export { useOnboarding } from './onboardingContext';

export default OnboardingContext;
